
import React from "react";
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import CsLineIcons from '../../cs-line-icons';

class ConditionalButton extends React.Component {

    get defaultButtonClass() {
        return "btn-icon btn-icon-start ms-0 ms-sm-1 w-100 w-md-auto";
    }

    get defaultPlacement() {
        return "bottom";
    }

    get button() {
        const {
            type,
            style,
            enabled,
            enabledVariant,
            disabledVariant,
            className,
            onEnabledClick,
            onDisabledClick,
            iconStyle,
            icon,
            children,
        } = this.props;

        return (
            <Button
                type={type || "button"}
                style={style}
                variant={enabled ? enabledVariant : disabledVariant}
                className={className || this.defaultButtonClass}
                disabled={!enabled}
                onClick={(e) => {
                    // If it's a submit button but disabled, belt-and-suspenders:
                    if (!enabled) {
                        e.preventDefault();
                        e.stopPropagation();
                        return onDisabledClick?.(e);
                    }
                    return onEnabledClick?.(e);
                }}
            >
                {icon ? <CsLineIcons style={iconStyle} icon={icon} /> : null}{" "}
                <span>{children}</span>
            </Button>
        );
    }

    get overlay() {
        return (
            <OverlayTrigger delay={{ show: 10, hide: 0 }} overlay={<Tooltip>{this.props.tooltip}</Tooltip>} placement={this.props.overlayPlacement || this.defaultPlacement}>
                {this.button}
            </OverlayTrigger>
        );
    }
    render() {
        if (this.props.display) {
            return (this.props.enabled && this.props.tooltip) ?
                    this.overlay
                    :
                    this.button
        }
        return null;
    }
}

export default ConditionalButton;
